<!--
	Name:			batch.vue
	Description:	Show the batch as a timeline block
	Remarks:		The position on the timeline is managed by the timestore repository
-->

<template>

	<!--left = endTime, position the batch to the left (margin-left:-100%)-->
	<div class="warming-tray time-block " :style="{left: xPosition + '%',  width : width + '%', 'min-height' : (Unit.height - 3) + 'px'}">

	</div>

</template>

<script>

	import timeStore from '../repositories/TimeManager';
	import warmingTrayRepository from '../repositories/WarmingTrayRepository';

    const WarmingTrayTimelineBlock = {

		props: {
			Unit : { type: Object }
		},

		data: function () {
            return { timeStoreState: timeStore.state, warmingTrays: warmingTrayRepository.warmingTrays  };
		},
		
		computed: {		
			width: function () {
				if (this.WarmingTray) {
                    return timeStore.calculateWidth((this.WarmingTray.deactivateAt.getTime() - this.WarmingTray.activateAt.getTime())/1000);
				}
				return 0;
			},
			xPosition: function () {
				if (this.WarmingTray) {                  
					return timeStore.calculateXPosition(this.WarmingTray.activateAt);
				}
			},
			WarmingTray: function () {				
                var tray = this.warmingTrays.find(a => a.id == this.Unit.unitGroupId);
				return tray;
			}
		},


	};

    export { WarmingTrayTimelineBlock as default };

</script>
